import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle"
export default class extends Controller {
  static targets = ["togglable"]
  static values = {
    open: { type: Boolean, default: false},
    clearField: { type: Boolean, default: false},
    submitOnToggleOpen: { type: Boolean, default: false},
    submitOnToggleClose: { type: Boolean, default: false}
  }

  connect() {
    if (this.openValue) {
      this.togglableTarget.classList.remove("hidden")
    }
  }

  toggle(e) {
    e.preventDefault()
    this.togglableTarget.classList.toggle("hidden")

    if (this.clearFieldValue) {
      this.togglableTarget.querySelector("input").value = ""
    }

    if (this.submitOnToggleOpenValue && !this.togglableTarget.classList.contains("hidden")) {
      this.togglableTarget.closest("form").requestSubmit()
    }

    if (this.submitOnToggleCloseValue && this.togglableTarget.classList.contains("hidden")) {
      this.togglableTarget.closest("form").requestSubmit()
    }
  }
}
